














































import Vue from "vue";
export default Vue.extend({
  name: "base-navbar",
  props: {
    positionTop: {
      type: [String, Number],
      default: "0px"
    },
    logoLink: {
      type: [String, Object]
    },
    noCollapse: {
      type: Boolean
    },
    imgURL: {
      type: String
    }
  },
  data: () => ({
    isCollapsed: true,
    isMobile: null,
    mediaQueryList: window.matchMedia("(max-width: 991px)")
  }),
  methods: {
    close() {
      this.isCollapsed = true;
    }
  },
  watch: {
    isMobile() {
      console.log(this.isMobile);
    }
  },
  mounted() {
    this.isMobile = this.mediaQueryList.matches;
    this.mediaQueryList.addListener((e: MediaQueryListEvent) => {
      this.isMobile = this.mediaQueryList.matches;
    });
  }
});
